import { Injectable } from '@angular/core';

function getNativeWindow(): Window {
    return window;
}

export interface Windows {
    UI: {
        Core: {
            SystemNavigationManager: {
                getForCurrentView: () => { appViewBackButtonVisibility: number };
            };
            AppViewBackButtonVisibility: { visible: 0; collapsed: 1 };
        };
    };
}

declare global {
    interface Window {
        Windows: Windows;
    }
}

@Injectable()
export class WindowService {
    public get nativeWindow(): Window {
        return getNativeWindow();
    }
}
